{
  "name": "thrwty-workspace",
  "version": "0.0.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-s-prod": "ng build system --configuration production",
    "build-w-prod": "ng build website --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.0",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-select/ng-select": "^14.2.3",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@popperjs/core": "^2.11.8",
    "@zoom/meetingsdk": "^4.0.0",
    "angular2-signaturepad": "^4.0.2",
    "aos": "^2.3.4",
    "bootstrap": "^5.3.3",
    "crypto-js": "^4.2.0",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.10.3",
    "jspdf": "^3.0.1",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-image-cropper": "^9.1.5",
    "ngx-infinite-scroll": "^19.0.0",
    "pdf-lib": "^1.17.1",
    "pdfjs-dist": "^5.4.54",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.0",
    "socket.io-client": "^4.8.1",
    "sweetalert2": "^11.17.2",
    "swiper": "^11.2.5",
    "tslib": "^2.3.0",
    "webm-duration-fix": "^1.0.4",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.1",
    "@angular/cli": "^19.0.2",
    "@angular/compiler-cli": "^19.0.0",
    "@angular/localize": "^19.0.0",
    "@types/aos": "^3.0.7",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "@types/qrcode": "^1.5.5",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^19.2.0",
    "typescript": "~5.6.2"
  }
}
